import type { ReactNode } from "react";
import { Stack, Text, ThemeIcon } from "@mantine/core";

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  /** Optional call-to-action (a Button, link, etc.). */
  action?: ReactNode;
}

/**
 * A titled empty state — composed from Mantine `Stack`/`Text`/`ThemeIcon`.
 * Renders so an unbuilt/empty screen reads as deliberate, not broken.
 */
export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <Stack align="center" gap="sm" py="xl" px="md" ta="center">
      {icon && (
        <ThemeIcon variant="light" color="gray" size="xl" radius="xl">
          <span aria-hidden="true" style={{ fontSize: 22, lineHeight: 1 }}>
            {icon}
          </span>
        </ThemeIcon>
      )}
      <Text fw={600} fz="lg">
        {title}
      </Text>
      {description && (
        <Text c="dimmed" fz="sm" maw={420}>
          {description}
        </Text>
      )}
      {action && <div>{action}</div>}
    </Stack>
  );
}
